// import stile
import "./App.css";

// import pacchetti
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

// import hooks
import { useAuthContext } from "./hooks/useAuthContext";
import { useState, useEffect } from "react";

// import componenti
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import { ResTecnicoAccess } from "./components/RoleBasedAccess";

// import pagine
import Dashboard from "./pages/dashboard/Dashboard";
import Login from "./pages/login/Login";
import Project from "./pages/project/Project";
import Create from "./pages/create/Create";
import Profile from "./pages/profile/Profile";
import Spesa from "./pages/spesa/Spesa";
import DettaglioSpesa from "./pages/dettaglioSpesa/DettaglioSpesa";
import Home from "./pages/home/Home";
import Giornata from "./pages/giornata/Giornata";
import SpeseDashboard from "./pages/spese/SpeseDashboard";
import Documenti from "./pages/documenti/Documenti";
import DettaglioDoc from "./pages/dettaglio/DettaglioDoc";
import Anagrafica from "./pages/anagrafica/Anagrafica";
import CheckSpeseDashboard from "./pages/checkSpese/CheckSpeseDashboard";
import AggiungiDoc from "./pages/aggiungiDoc/AggiungiDoc";
import AdminPanel from "./pages/adminPanel/AdminPanel";
import FoglioPresenza from "./pages/foglioPresenza/FoglioPresenza";
import PresenzeCheck from "./pages/presenzeCheck/PresenzeCheck";
import StampaSpese from "./pages/stampaSpese/StampaSpese";
import GestioneUtenti from "./pages/gestioneUtenti/gestioneUtenti";
import DocUpdate from "./pages/documentsUpdate/DocUpdate";
import DocumentiUtenti from "./pages/documentsUpdate/DocumentiUtenti";
import Badge from "./pages/badge/Badge";
import PresenzeAdmin from "./pages/presenzeAdmin/PresenzeAdmin";
import PresenzeTecnico from "./pages/presenzeTecnico/PresenzeTecnico";
import Automezzi from "./pages/automezzi/Automezzi";
import AutomezziDashboard from "./pages/automezziDashboard/AutomezziDashboard";
import CalendarioAutomezzi from "./pages/calendarioAutomezzi/CalendarioAutomezzi";
import DocumentScanner from "./pages/documentScanner/DocumentScanner";
import GestioneDocumenti from "./pages/gestioneDocumenti/GestioneDocumenti";
import DocumentiAziendali from "./pages/documentiAziendali/DocumentiAziendali";
import RegistroAcquisti from "./pages/registroAcquisti/RegistroAcquisti";
import ConsuntiviList from "./pages/admin/consuntivi/ConsuntiviList";
import EsempioRuoli from "./pages/EsempioRuoli";
import GestioneRuoli from "./pages/admin/GestioneRuoli";
import SupervisioneDipendenti from "./pages/admin/SupervisioneDipendenti";
import ResTecnicoPage from "./pages/resTecnico/ResTecnicoPage";
import PianificazioneTecnico from "./pages/resTecnico/PianificazioneTecnico";
import PianificazioneFinanziaria from "./pages/pianificazioneFinanziaria/PianificazioneFinanziaria";
import ExcelImportExample from "./pages/excelImport/ExcelImportExample";
import CsvImport from "./pages/csvImport/CsvImport";
import ScadenzeClienti from "./pages/scadenzeClienti/ScadenzeClienti";
import AnaliticaAdmin from "./pages/analiticaAdmin/AnaliticaAdmin";
import Ricavi from "./pages/ricavi/Ricavi";
import Vestiario from "./pages/vestiario/Vestiario";
import Timbratore from "./pages/timbratore/Timbratore";
import PresenzeDef from "./pages/presenze/PresenzeDef";
import RichiestaFerie from "./pages/ferie/RichiestaFerie";
import GestioneFerieTecnico from "./pages/resTecnico/GestioneFerieTecnico";
import SupervisioneFerieAdmin from "./pages/admin/SupervisioneFerieAdmin";
import SpaccaturaCosti from "./pages/admin/spaccaturaCosti/SpaccaturaCosti";
import Guida from "./pages/guida/Guida";
import CreazionePOS from "./pages/creazionePOS/CreazionePOS";
import TabellaPaghe from "./pages/admin/tabellaPaghe/TabellaPaghe";
import AvvisiDipendenti from "./pages/admin/avvisiDipendenti/AvvisiDipendenti";
import RichiesteInfoDocumenti from "./pages/richiesteInfo/RichiesteInfoDocumenti";
import RichiesteInfoTecnico from "./pages/resTecnico/RichiesteInfoTecnico";
import DashboardReperibilita from "./pages/resTecnico/DashboardReperibilita";
import TabellaManutenzioni from "./pages/resTecnico/TabellaManutenzioni";
import ContrattiClienti from "./pages/contrattiClienti/ContrattiClienti";
import Tickets from "./pages/tickets/Tickets";
import TicketsTecnico from "./pages/resTecnico/TicketsTecnico";

// Componente wrapper per gestire la chiusura della sidebar al cambio di pagina
function AppContent() {
  const { user } = useAuthContext();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  // Effetto per chiudere la sidebar quando cambia la pagina (solo su mobile)
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  useEffect(() => {
    const checkIfMobile = () => {
      const mobile = window.innerWidth <= 767;
      setIsMobile(mobile);
      if (mobile) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    // Gestione dell'evento toggle-sidebar dalla navbar
    const handleToggleSidebar = () => {
      setIsSidebarOpen((prevState) => !prevState);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    window.addEventListener("toggle-sidebar", handleToggleSidebar);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
      window.removeEventListener("toggle-sidebar", handleToggleSidebar);
    };
  }, []);

  return (
    <>
      {user && (
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      )}
      <div
        className={`container ${
          isMobile && !isSidebarOpen ? "sidebar-hidden" : ""
        }`}
      >
        <Navbar />
        <div className="content">
          <Routes>
            <Route
              path="/"
              element={user ? <Home /> : <Navigate to="/login" />}
            />
            <Route
              path="/giornata/:date"
              element={user ? <Giornata /> : <Navigate to="/login" />}
            />
            <Route
              path="/login"
              element={!user ? <Login /> : <Navigate to="/" />}
            />
            <Route
              path="/signup"
              element={<Navigate to={user ? "/" : "/login"} />}
            />
            <Route
              path="/anagraficaDipendente/:id"
              element={user ? <Anagrafica /> : <Navigate to="/login" />}
            />
            <Route
              path="/create"
              element={user ? <Create /> : <Navigate to="/login" />}
            />
            <Route
              path="/projects"
              element={user ? <Dashboard /> : <Navigate to="/login" />}
            />
            <Route
              path="/spesa"
              element={user ? <Spesa /> : <Navigate to="/login" />}
            />
            <Route
              path="/spese"
              element={user ? <SpeseDashboard /> : <Navigate to="/login" />}
            />
            <Route
              path="/stampaSpese"
              element={user ? <StampaSpese /> : <Navigate to="/login" />}
            />
            <Route
              path="/foglioPresenza"
              element={user ? <FoglioPresenza /> : <Navigate to="/login" />}
            />
            <Route
              path="/presenze-admin"
              element={user ? <PresenzeAdmin /> : <Navigate to="/login" />}
            />
            <Route
              path="/presenzeCheck"
              element={user ? <PresenzeCheck /> : <Navigate to="/login" />}
            />
            <Route
              path="/amministrazione"
              element={user ? <AdminPanel /> : <Navigate to="/login" />}
            />
            <Route
              path="/tabella-paghe"
              element={user ? <TabellaPaghe /> : <Navigate to="/login" />}
            />
            <Route
              path="/avvisi-dipendenti"
              element={user ? <AvvisiDipendenti /> : <Navigate to="/login" />}
            />
            <Route
              path="/speseCheck"
              element={
                user ? <CheckSpeseDashboard /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/docUpdate"
              element={user ? <DocUpdate /> : <Navigate to="/login" />}
            />
            <Route
              path="/documentiUtenti"
              element={user ? <DocumentiUtenti /> : <Navigate to="/login" />}
            />
            <Route
              path="/badge"
              element={user ? <Badge /> : <Navigate to="/login" />}
            />
            <Route
              path="/user-management"
              element={user ? <GestioneUtenti /> : <Navigate to="/login" />}
            />
            <Route
              path="/caricaDoc"
              element={user ? <AggiungiDoc /> : <Navigate to="/login" />}
            />
            <Route
              path="/automezzi-dashboard"
              element={user ? <AutomezziDashboard /> : <Navigate to="/login" />}
            />
            <Route
              path="/calendario-automezzi"
              element={
                user ? <CalendarioAutomezzi /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/automezzi"
              element={user ? <Automezzi /> : <Navigate to="/login" />}
            />
            <Route
              path="/documenti"
              element={user ? <Documenti /> : <Navigate to="/login" />}
            />
            <Route
              path="/documenti/:id"
              element={user ? <DettaglioDoc /> : <Navigate to="/login" />}
            />
            <Route
              path="/project/:id"
              element={user ? <Project /> : <Navigate to="/login" />}
            />
            <Route
              path="/spesa/:id"
              element={user ? <DettaglioSpesa /> : <Navigate to="/login" />}
            />
            <Route
              path="/profile/:id"
              element={user ? <Profile /> : <Navigate to="/login" />}
            />
            <Route
              path="/esempio-ruoli"
              element={user ? <EsempioRuoli /> : <Navigate to="/login" />}
            />
            <Route
              path="/gestione-ruoli"
              element={user ? <GestioneRuoli /> : <Navigate to="/login" />}
            />
            <Route
              path="/supervisione-dipendenti"
              element={
                user ? <SupervisioneDipendenti /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/restecnico"
              element={user ? <ResTecnicoPage /> : <Navigate to="/login" />}
            />
            <Route
              path="/dashboard-reperibilita"
              element={
                user ? <DashboardReperibilita /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/pianificazione-tecnico"
              element={
                user ? <PianificazioneTecnico /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/tabella-manutenzioni"
              element={
                user ? <TabellaManutenzioni /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/presenze-tecnico"
              element={user ? <PresenzeTecnico /> : <Navigate to="/login" />}
            />
            <Route
              path="/pianificazione-finanziaria"
              element={
                user ? <PianificazioneFinanziaria /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/excel-import"
              element={user ? <ExcelImportExample /> : <Navigate to="/login" />}
            />
            <Route
              path="/csv-import"
              element={user ? <CsvImport /> : <Navigate to="/login" />}
            />
            <Route
              path="/scadenze-clienti"
              element={user ? <ScadenzeClienti /> : <Navigate to="/login" />}
            />
            <Route
              path="/analitica-admin"
              element={user ? <AnaliticaAdmin /> : <Navigate to="/login" />}
            />
            <Route
              path="/tickets"
              element={user ? <Tickets /> : <Navigate to="/login" />}
            />
            <Route
              path="/ricavi"
              element={user ? <Ricavi /> : <Navigate to="/login" />}
            />
            <Route
              path="/spaccatura-costi"
              element={user ? <SpaccaturaCosti /> : <Navigate to="/login" />}
            />
            <Route
              path="/richieste-info-tecnico"
              element={
                user ? <RichiesteInfoTecnico /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/richieste-info-documenti"
              element={
                user ? <RichiesteInfoDocumenti /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/vestiario"
              element={user ? <Vestiario /> : <Navigate to="/login" />}
            />
            <Route
              path="/timbratore"
              element={user ? <Timbratore /> : <Navigate to="/login" />}
            />
            <Route
              path="/presenze-def"
              element={user ? <PresenzeDef /> : <Navigate to="/login" />}
            />
            <Route
              path="/richiesta-ferie"
              element={user ? <RichiestaFerie /> : <Navigate to="/login" />}
            />
            <Route
              path="/gestione-ferie-tecnico"
              element={
                user ? <GestioneFerieTecnico /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/supervisione-ferie-admin"
              element={
                user ? <SupervisioneFerieAdmin /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/guida"
              element={user ? <Guida /> : <Navigate to="/login" />}
            />
            <Route
              path="/document-scanner"
              element={user ? <DocumentScanner /> : <Navigate to="/login" />}
            />
            <Route
              path="/gestione-documenti"
              element={user ? <GestioneDocumenti /> : <Navigate to="/login" />}
            />
            <Route
              path="/documenti-aziendali"
              element={user ? <DocumentiAziendali /> : <Navigate to="/login" />}
            />
            <Route
              path="/registroAcquisti"
              element={user ? <RegistroAcquisti /> : <Navigate to="/login" />}
            />
            <Route
              path="/consuntivi-list"
              element={user ? <ConsuntiviList /> : <Navigate to="/login" />}
            />
            <Route
              path="/contratti-clienti"
              element={user ? <ContrattiClienti /> : <Navigate to="/login" />}
            />
            <Route
              path="/tickets-tecnico"
              element={
                <ResTecnicoAccess>
                  <TicketsTecnico />
                </ResTecnicoAccess>
              }
            />
            <Route
              path="/creazione-pos"
              element={user ? <CreazionePOS /> : <Navigate to="/login" />}
            />
          </Routes>
        </div>
      </div>
    </>
  );
}

function App() {
  const { authIsReady } = useAuthContext();

  return (
    <div className="App">
      {authIsReady && (
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;

/* pagine da fare

- dashboard (homepage)
- login
- registrazione
- create
- project (con dettagli)

*/
